// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__57yL3","label":"Textarea_label__MFn6d","default":"Textarea_default__vI9AC","small":"Textarea_small__1R1NI","large":"Textarea_large__3s8lR"};